import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import Modal from '@xo-union/tk-component-modals';
import { Link, Button } from '@xo-union/tk-component-buttons';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import styles from './message-guest-modal.scss';

@inject('gdsUiState')
@observer
class RsvpSettingsModal extends Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
  };

  onCancel = () => {
    const { gdsUiState } = this.props;
    gdsUiState.setMessageGuestModalView(false);
  };

  render() {
    return (
      <div className={styles.guestModalContainer}>
        <Modal onClose={this.onCancel} size="lg">
          <h1>First, Start Your Wedding Website</h1>
          <div className={styles.infoSection}>
            You need a Wedding Website to send messages to your guests. Start your site now to easily manage your guest
            communications all in one place.
          </div>
          <div className={styles.ctaContainer}>
            <Button className={styles.cancelButton} onClick={this.onCancel}>
              Cancel
            </Button>
            <Link href="/gs/dashboard">Get Started</Link>
          </div>
        </Modal>
      </div>
    );
  }
}

export default RsvpSettingsModal;
